import { Component, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { NotificationTheme } from '@fcom/ui-components';

@Component({
  selector: 'fin-newsletter-notification',
  templateUrl: './newsletter-notification.component.html',
})
export class NewsletterNotificationComponent implements OnInit {
  readonly NotificationTheme = NotificationTheme;

  showNotification = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    const route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;

    if (route.queryParamMap.has('newsletterSubscribed')) {
      this.showNotification = true;
      this.router.navigate([], {
        replaceUrl: true,
        state: { skipFilterSet: true },
      });
    }
  }
}
